import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { nuovoArticolo } from "../utils/acquisti";

/** Voci del Listino materiali dell'organizzazione (per i suggerimenti). */
export function useListinoMateriali(orgId) {
  const [voci, setVoci] = useState([]);
  useEffect(() => {
    if (!orgId) return;
    return onSnapshot(query(collection(db, "listinoMateriali"), where("organizationId", "==", orgId)),
      snap => setVoci(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(v => v.descrizione)),
      () => setVoci([]));
  }, [orgId]);
  return voci;
}

/** Cerca nel listino la voce scritta (per descrizione esatta o per codice). */
export function trovaInListino(listino, testo) {
  const t = String(testo || "").trim().toLowerCase();
  if (!t) return null;
  return listino.find(v => String(v.descrizione || "").trim().toLowerCase() === t)
      || listino.find(v => v.codiceArticolo && String(v.codiceArticolo).trim().toLowerCase() === t)
      || null;
}

/**
 * Righe di articoli di una richiesta NF (facoltative). Scrivendo la descrizione compaiono i
 * suggerimenti dal Listino materiali; scegliendone uno si compilano codice, unità di misura
 * e prezzo indicativo (modificabili).
 */
export default function ArticoliNF({ articoli, onChange, listino, disabilitato = false }) {
  const idLista = "listino-nf";
  const aggiorna = (i, campo, valore) => {
    const nuovi = articoli.map((a, j) => j === i ? { ...a, [campo]: valore } : a);
    if (campo === "descrizione") {
      const v = trovaInListino(listino, valore);
      if (v) nuovi[i] = { ...nuovi[i], descrizione: v.descrizione, codice: nuovi[i].codice || v.codiceArticolo || "",
        unitaMisura: nuovi[i].unitaMisura || v.unitaMisura || "", prezzoIndicativo: nuovi[i].prezzoIndicativo || (v.prezzoUnitario != null ? String(v.prezzoUnitario) : "") };
    }
    onChange(nuovi);
  };
  const inp = { width: "100%", padding: "6px 8px", border: "1px solid #e5e7eb", borderRadius: 6, fontSize: 12, fontFamily: "'Inter',sans-serif", boxSizing: "border-box" };
  return (
    <div>
      <datalist id={idLista}>
        {listino.slice(0, 500).map(v => <option key={v.id} value={v.descrizione}>{[v.codiceArticolo, v.unitaMisura, v.prezzoUnitario != null && v.prezzoUnitario !== "" ? `€ ${v.prezzoUnitario}` : ""].filter(Boolean).join(" · ")}</option>)}
      </datalist>
      {articoli.length > 0 && (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 520 }}>
            <thead><tr style={{ fontSize: 10, color: "#6b7280", textAlign: "left" }}>
              <th style={{ padding: "2px 4px", width: "42%" }}>Descrizione</th><th style={{ padding: "2px 4px" }}>Codice</th>
              <th style={{ padding: "2px 4px", width: 70 }}>Q.tà</th><th style={{ padding: "2px 4px", width: 60 }}>U.M.</th>
              <th style={{ padding: "2px 4px", width: 90 }}>Prezzo indic. €</th><th style={{ width: 24 }}/></tr></thead>
            <tbody>{articoli.map((a, i) => (
              <tr key={a.id || i}>
                <td style={{ padding: 2 }}><input style={inp} list={idLista} disabled={disabilitato} value={a.descrizione} onChange={e => aggiorna(i, "descrizione", e.target.value)} placeholder="Es. Cavo FG16OR16 3x2,5"/></td>
                <td style={{ padding: 2 }}><input style={inp} disabled={disabilitato} value={a.codice} onChange={e => aggiorna(i, "codice", e.target.value)}/></td>
                <td style={{ padding: 2 }}><input style={inp} disabled={disabilitato} value={a.quantita} onChange={e => aggiorna(i, "quantita", e.target.value)} inputMode="decimal"/></td>
                <td style={{ padding: 2 }}><input style={inp} disabled={disabilitato} value={a.unitaMisura} onChange={e => aggiorna(i, "unitaMisura", e.target.value)} placeholder="pz, m…"/></td>
                <td style={{ padding: 2 }}><input style={inp} disabled={disabilitato} value={a.prezzoIndicativo} onChange={e => aggiorna(i, "prezzoIndicativo", e.target.value)} inputMode="decimal" placeholder="dall'offerta"/></td>
                <td style={{ padding: 2, textAlign: "center" }}>{!disabilitato && <button type="button" title="Togli riga" onClick={() => onChange(articoli.filter((_, j) => j !== i))} style={{ border: "none", background: "none", cursor: "pointer", color: "#9ca3af", fontSize: 14 }}>✕</button>}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
      {!disabilitato && (
        <button type="button" onClick={() => onChange([...articoli, nuovoArticolo()])}
          style={{ marginTop: 6, fontSize: 12, color: "#7c3aed", background: "none", border: "1px dashed #c4b5fd", borderRadius: 6, padding: "5px 10px", cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
          + Aggiungi articolo
        </button>
      )}
    </div>
  );
}
